export const loadLivefyre = (cookieloginvalue, cookievalue, logincb) => {
    let tokencookie = cookievalue;
    let logincookie = cookieloginvalue;
    
    var dataLiveFyre = document.querySelector("#tokenLF");
    if (dataLiveFyre != null) {
        var LiveFyre = {};

        LiveFyre.networkConfig = {
            network: 'la-nacion.fyre.co',
        };

        LiveFyre.customStrings = {
            "editProfile": "Editar perfil",
            "modQ": "Configuración de notificaciones",
            "signIn": "Ingresar",
            "signOut": "Salir",
            "siteAdmin": "Moderación",
            "archiveHeaderTitle": "Cargar imagen desde archivo",
            "archiveShowMore": "Mostrar más",
            "backToHotThreads": "Volver a \"Conversaciones destacadas\"",
            "backToComments": "Volver a \"lo más nuevo\"",
            "sortHotThreads": "Conversaciones destacadas",
            "sortNewest": "Más nuevos",
            "sortOldest": "Más viejos",
            "sortSeparator": "|",
            "sortTopComments": "Destacados",
            "streamSorting": "Cargando",
            "hotThreadsContentNotFoundMsg": "Todavía no hay suficientes comentarios",
            "topCommentsContentNotFoundMsg": "Todavía no hay suficientes \"me gusta\"",
            "threadBreakoutButton": "Ver conversación completa",
            "showMore": "Ver más",
            "showMoreLiveblog": "Ver más posteos",
            "streamRefreshMsg": "Lo nuevo",
            "refresh": "Actualizar",
            "newComment": "Nuevo comentario",
            "newComments": "Nuevos comentarios",
            "newReply": "Nueva respuesta",
            "newReplies": "Nuevas respuestas",
            "listenerCount": "persona siguiendo",
            "listenerCountPlural": "personas siguiendo",
            "commentCountLabel": "comentario",
            "commentCountLabelPlural": "comentarios",
            "liveblogPostCountLabel": "posteo",
            "liveblogPostCountLabelPlural": "posteos",
            "commentNotifier": "Nuevo comentario",
            "commentNotifierPlural": "Nuevos comentarios",
            "liveblogNotifier": "Nuevo posteo",
            "liveblogNotifierPlural": "Nuevos posteos",
            "hovercardViewProfile": "Ver perfil",
            "moderator": "moderador",
            "timeDaysAgo": "día atrás",
            "timeDaysAgoPlural": "días atrás",
            "timeHoursAgo": "una hora",
            "timeHoursAgoPlural": "unas horas",
            "timeInDays": "en 1 día",
            "timeInDaysPlural": "en %s días",
            "timeInHours": "en %s hora",
            "timeInHoursPlural": "en %s horas",
            "timeInMinutes": "en %s minuto",
            "timeInMinutesPlural": "en %s minutos",
            "timeJustNow": "Ahora mismo",
            "timeMinutesAgo": "minuto atrás",
            "timeMinutesAgoPlural": "minutos atrás",
            "commentTombstone": "El comentario ha sido borrado. Las respuestas que generó se siguen mostrando aquí abajo.",
            "likesPlural": "Me gusta",
            "likesSingular": "Me gusta",
            "moderatorEditTimestamp": "Editado por un moderador",
            "permalinkNotFoundMsg": "",
            "quickProfileTooltip": "Ver perfil",
            "featuredCommentsTitlePlural": "Destacado por el editor",
            "featuredCommentsTag": "Destacado por el editor",
            "flagButton": "Reportar",
            "flagCancelButton": "Cancelar",
            "flagCommentTooltip": "Reportar",
            "flagConfirmationMessage": "Reportar %s's comentario como %s?",
            "flagConfirmButton": "Confirmar",
            "flagDefaultSelectOption": "Seleccionar",
            "flagDisagree": "En desacuerdo",
            "flagDisagreeButton": "En desacuerdo",
            "flagDisagreeCommentTooltip": "En desacuerdo",
            "flagEmail": "Email",
            "flagEmailPlaceholder": "usuario@dominio.com",
            "flagNotes": "Notas",
            "flagNotesPlaceholder": "Escribe aquí...",
            "flagOffensive": "Ofensivo",
            "flagOffensiveButton": "Ofensivo",
            "flagOffensiveCommentTooltip": "Ofensivo",
            "flagOffTopic": "Fuera de tema",
            "flagOffTopicButton": "Fuera de tema",
            "flagOffTopicCommentTooltip": "Fuera de tema",
            "flagSpam": "Spam",
            "flagSpamButton": "Spam",
            "flagSpamCommentTooltip": "Spam",
            "flagSubtitle": "Reportar como",
            "flagSuccessMsg": "Este comentario ha sido reportado.",
            "flagTitle": "Reportar comentario",
            "follow": "Seguir",
            "liveblogFollow": "Seguir 'Liveblog'",
            "liveblogUnfollow": "Dejar de seguir 'Liveblog'",
            "unfollow": "Dejar de seguir",
            "likeButton": "Me gusta",
            "unlikeButton": "Me gusta",
            "loadingPermalink": "Cargando URL",
            "shareButton": "Compartir",
            "shareButtonText": "Compartir",
            "shareDefaultText": "Mira el comentario de %s",
            "shareLabel": "Compartir en:",
            "sharePermalink": "URL",
            "shareText": "Acabo de escribir un comentario. ¡Miralo!",
            "shareTextFacebook": "Acabo de escribir un comentario. ¡Miralo!",
            "shareTextLinkedin": "Acabo de escribir un comentario. ¡Miralo!",
            "shareTextTwitter": "Acabo de escribir un comentario. ¡Miralo!",
            "shareTitle": "Compartir comentario",
            "mentionCancelButton": "Cancelar",
            "mentionConfirmButton": "Confirmar",
            "mentionDefaultText": "¡Te mencioné en un comentario!",
            "mentionErrorGeneral": "¡Ups! Algo no funcionó. Ya fue reportado.",
            "mentionErrorNoneSelected": "Tenés que mencionar al menos una persona.",
            "mentionMenuTitle": "Conectá tu cuenta para mencionar a tus amigos:",
            "mentionSubtitleFacebook": "Compartir el posteo de Facebook con:",
            "mentionSubtitleTwitter": "Compartir el tweet con:",
            "mentionSuccessMsg": "Las menciones se han realizado exitosamente.",
            "mentionTitle": "Compartir mención",
            "voteDownvote": "No",
            "voteReplyTitle": "¿Te ha ayudado esta respuesta?",
            "voteTitle": "¿Es valioso este comentario?",
            "voteUpvote": "Si",
            "customHtmlDialogTitle": "Add Custom HTML",
            "editButton": "Editar",
            "editorDisabled": "Esta nota se encuentra cerrada a comentarios.",
            "livechatOtherInstruction": "Presioná CMD+Enter para comentar",
            "livechatPostEditButton": "Editar",
            "livechatPostButtonLabel": "Comentar",
            "livechatWindowsInstruction": "Presioná CTRL + Enter para comentar",
            "postAsButton": "Comentar",
            "postEditAsButton": "Editar",
            "postEditCancelButton": "Cancelar",
            "postEditButton": "Comentar",
            "postReplyAsButton": "Responder",
            "postReplyButton": "Responder",
            "postButton": "Comentar",
            "replyButton": "Responder",
            "replyButtonSingular": "Respuesta",
            "replyButtonPlural": "Respuestas",
            "banCancelButton": "Cancelar",
            "banConfirmation": "¿Estás seguro que querés bannear a este usuario?",
            "banConfirmButton": "Ok",
            "banTitle": "Bannear usuario",
            "banUserButton": "Bannear usuario",
            "banUserTooltip": "Bannear usuario",
            "bozoButton": "Bozo",
            "bozoCommentTooltip": "Bozo",
            "deleteButton": "Borrar",
            "deleteCommentTooltip": "Borrar",
            "featureButton": "Destacado",
            "featureCommentTooltip": "Destacado",
            "featuredCommentTooltip": "Dejar de destacar",
            "pendingComment": "pendiente",
            "shareCommentTooltip": "Compartir",
            "unfeatureButton": "Dejar de destacar",
            "errorAuthError": "No estás autorizado a comentar en esta conversación.",
            "errorCommentsNotAllowed": "Los comentarios no están habilitados en esta nota.",
            "errorDefault": "Ocurrió un error. Por favor intente nuevamente.",
            "errorDuplicate": "Disculpe. No se puede comentar dos veces lo mismo.",
            "errorEditDuplicate": "Tiene que modificar el cuerpo del comentario cuando lo edita.",
            "errorEditNotAllowed": "No estás autorizado a editar el comentario.",
            "errorEditTimeExceeded": "Disculpe, pero el tiempo para editar el comentario expiró.",
            "errorEmpty": "Parece que estás intentando publicar un comentario vacío.",
            "errorExpired": "La sesión ha expirado, por favor actualizá la página.",
            "errorFlagNotSelected": "Por favor seleccione el motivo del reporte.",
            "errorGuestLiked": "Disculpe, solo los usuarios registrados pueden sumar su \"Me gusta\".",
            "errorInsufficientPermissions": "No posee los permisos suficientes.",
            "errorInvalidChar": "Parece que hay un caractér inválido. Por favor revise el texto.",
            "errorLikeOwnComment": " No es posible poner \"Me gusta\" en un comentario propio.",
            "errorMalformed": "Parece que hay un error en el contenido del comentario. Por favor revíselo.",
            "errorMaxChars": "Disculpe, su comentario es muy largo. Por favor edítelo y vuelva a intentarlo.",
            "errorMediaNotAvailable": "Este contenido ya no se encuentra visible.",
            "errorShowMore": "Hubo un error en la carga de nuevos comentarios.",
            "MultipleMediaNotAllowedError": "Sólo puede adjuntar un contenido por comentario.",
            "menuShareTitle": "Compartir",
            "toggleCollapse": "Expandir / Contraer",
            "mentionFacebookConnect": "Facebook",
            "mentionFacebookFetching": "Cargando Contactos",
            "mentionTwitterConnect": "Twitter",
            "mentionTwitterFetching": "Cargando Contactos"

        };

        LiveFyre.convConfig = {
            siteId: '356483',
            articleId: dataLiveFyre.getAttribute("data-entrada"),
            el: 'livefyre',
            collectionMeta: dataLiveFyre.getAttribute("data-id"),
            "datetimeFormat": {
                minutesUntilAbsoluteTime: 4,
                absoluteFormat: 'HH:mm dd/MM/y'
            },
            editorCss: {
                background: '#ccc',
                color: 'red',
                font: '30px "Helvetica Neue", Helvetica, Arial, Geneva, sans-serif'
            }
        };

        LiveFyre.convConfig.initialNumVisible = '10';

        LiveFyre.attachmentDelegate = function (embedObj) {
            var providersToBlock = ['slideshare', 'scribd', 'facebook', 'photobucket', 'twitter', 'imgur', 'tinypic', 'fbcdn', 'cloudfront', 'flickr', '4.bp.blogspot', '1.bp.blogspot', 'orig00.deviantart', 'tira-la-kadena.tumblr', '41.media.tumblr', 'i.ytimg.', 'grand-hotel-calafate.tumblr', 'orig11.deviantart', 'orig07.deviantart', 'orig00.deviantart', 'orig10.deviantart', 'encrypted-tbn1', 'encrypted-tbn2'];
            for (var i = 0, len = providersToBlock.length; i < len; i++) {
                if (embedObj.provider_url.indexOf(providersToBlock[i]) > -1) {
                    return false;
                }
            }
            return true;
        };
        LiveFyre.networkConfig["attachmentDelegate"] = LiveFyre.attachmentDelegate;
        LiveFyre.networkConfig["strings"] = LiveFyre.customStrings;
        LiveFyre.convConfig.postToButtons = ['tw', 'fb'];

        Livefyre.require(['fyre.conv#3', 'auth'], function (Conv, auth) {

            var isUserLoggedIn = function () {
                if (tokencookie != '' && logincookie != '') {
                    return true;
                }
                else {
                    document.getElementById("comentarios").setAttribute("class", "no-logueado");
                    return false;
                }
            }

            if (isUserLoggedIn()) {
                if (!LiveFyre.autenticado) {
                    auth.authenticate({ livefyre: tokencookie });
                    LiveFyre.autenticado = true;
                    LiveFyre.logueoUsuario = true;
                }
            }

            new Conv(LiveFyre.networkConfig, [LiveFyre.convConfig], function (widget) {
                widget.on('commentPosted', function (data) {
                   // console.log('GA: CommentPosted');
                    //ga('send', 'event', 'livefyre', 'commentPosted');
                });
                widget.on('commentFlagged', function (data) {
                   // console.log('GA: CommentFlagged');
                    //ga('send', 'event', 'livefyre', 'commentFlagged');
                });
                widget.on('commentLiked', function (data) {
                   // console.log('GA: CommentLiked');
                    //ga('send', 'event', 'livefyre', 'commentLiked');
                });
                widget.on('commentShared', function (data) {
                   // console.log('GA: CommentShared');
                    //ga('send', 'event', 'livefyre', 'commentShared');
                });
                widget.on('socialMention', function (data) {
                  //  console.log('GA: SocialMention');
                    //ga('send', 'event', 'livefyre', 'socialMention');
                });
                widget.on('showMore', function (data) {
                   // console.log('GA: ShowMore');
                    //ga('send', 'event', 'livefyre', 'verMas', 'verMas');
                });
                widget.on('initialRenderComplete', function (data) {

                    if (isUserLoggedIn()) {
                        if (!LiveFyre.autenticado) {
                            auth.authenticate({ livefyre: tokencookie });
                            LiveFyre.autenticado = true;
                            LiveFyre.logueoUsuario = true;
                        }
                    }
                    else {
                        fyre.conv.logout();
                    }

                });
            });

            auth.delegate({ 
                login: function (cb) {
                    logincb();   
                    cb(null,
                        {
                            livefyre: tokencookie
                        });
                },
                logout: function (finishLogout) {
                    finishLogout(null);
                },
                viewProfile: function (author) {
                    var url, authorId = author.id.match("[0-9]+");
                    if ((author.profileUrl != null) && (authorId.length > 0)) {
                        url = author.profileUrl;
                        var win = window.open(url, '_blank');
                        win.focus();
                    }
                }
            });
        });
        let link = document.createElement("link");
        link.id = "miCSS";
        link.rel = "stylesheet";
        // set the type attribute
        link.type = "text/css";
        // make the script element load file
        link.src = "~/livefyre.css";
        // finally insert the element to the body element in order to load the script
        //script.onload = function() {
        //}
        document.getElementsByTagName("head")[0].appendChild(link);
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/livefyre/framework.js